import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class MessageService {
  private messageReloadSource = new BehaviorSubject<boolean>(false);
  currentReloadMessage$ = this.messageReloadSource.asObservable();

  private initSessionMonitoringSource = new BehaviorSubject<boolean>(false);
  initSessionMonitoringState$ = this.initSessionMonitoringSource.asObservable();

  sendReloadMessage(value: boolean) {
    this.messageReloadSource.next(value);
  }

  initSessionMonitoring(value: boolean = true) {
    this.initSessionMonitoringSource.next(value);
  }
}
